export const config = {
  url: process.env.REACT_APP_BASE_URL 
};